import { render, staticRenderFns } from "./PAlertItem.vue?vue&type=template&id=20682e47"
import script from "./PAlertItem.vue?vue&type=script&lang=js"
export * from "./PAlertItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports